import { Component, ChangeDetectorRef, ViewChild } from '@angular/core';
import { BaseAppMComponent } from '@app/cp/shared/base-components/base-app-m.component';
import { SaveMode } from '@app/cp/shared/enums/SaveMode';
import { GlobalsService } from '@app/cp/shared/services/globals.service';
import { DQOIReferenceDataQuery } from '@app/cp/dqoi/state/dqoi-reference-data.query';
import { DomSanitizer } from '@angular/platform-browser';
import { DomainDialogComponent } from '../../shared/components/domain-dialog/domain-dialog.component';
import { ConfirmOutput } from '../../shared/models/ConfirmOutput';
import { CPDialogResult } from '../../shared/enums/CPDialogResult';
import { BillingCodesDialogComponent } from '../../shared/domain-data/billing-codes-dialog/billing-codes-dialog.component';
import { PartTypeDialogComponent } from "@app/cp/shared/domain-data/part-type-dialog/part-type-dialog.component";
import { PartCategoryDialogComponent } from "@app/cp/shared/domain-data/part-category-dialog/part-category-dialog.component";
import { PartSubcategoryDialogComponent } from '../../shared/domain-data/part-subcategory-dialog/part-subcategory-dialog.component';
import { FeatureFlagService } from "@app/cp/shared/services/feature-flag.service";

@Component({
    selector: 'cp-basedata',
    templateUrl: './basedata.component.html',
    styleUrls: ['./basedata.component.scss'],
    standalone: false
})
export class BaseDataComponent extends BaseAppMComponent<null, null, null, null> {
    initialTab = 0;
    photo: any;
    hasPhoto: boolean = false;
    public events: string[] = [];
    public imagePreviews: any[] = [];
    activeExport: boolean = false;
    //regulatedTypes = RegulatedTypes;
    //constructionTypes = ConstructionTypes;
    //vehicleTypes = VehicleTypes;
    //contractTerms = ContractTerms;
    appCode: string = "BaseData";
    urlStart: string;
    @ViewChild('domainDialog') public domainDialog: DomainDialogComponent;
    @ViewChild('billingCodesDialog') public billingCodesDialog: BillingCodesDialogComponent;
    @ViewChild('partTypeDialog') public partTypeDialog: PartTypeDialogComponent;
    @ViewChild('partCategoryDialog') public partCategoryDialog: PartCategoryDialogComponent;
    @ViewChild('partSubcategoryDialog') public partSubcategoryDialog: PartSubcategoryDialogComponent;

    constructor(

        globals: GlobalsService,
        qry_rd: DQOIReferenceDataQuery,
        featureFlagService: FeatureFlagService,
        private cd: ChangeDetectorRef,

        private sanitizer: DomSanitizer) {
        super(globals, featureFlagService, qry_rd);
        this.addtlDataClass = "AdditionalVehicleData";
        this.saveMode = SaveMode.individual;
        //this.saveMode = SaveMode.all;

    }

    refreshRefferenceData(data: ConfirmOutput) {

        if (data.dialogResult === CPDialogResult.ok) {
            //this.refreshRefference();
        }
    }

    showPopup(id: number) {
        this.domainDialog.show(id);
    }
}
